import { apiClient } from '@app/api';
import { ThumbnailInfo } from '@app/core/hooks/api/useApiThumbnailsRange';
import { useQuery } from '@tanstack/react-query';

export type UseThumbnailResult = {
  isLoading: boolean;
  info: ThumbnailInfo | null;
};

export function useThumbnailForSegment(stationId: string, segmentId: number): UseThumbnailResult {
  const thumbnailQuery = useQuery({
    queryKey: ['segment-thumbnail', stationId, segmentId],
    queryFn: () => apiClient.segments.fetchThumbnail(stationId, segmentId),
    // Keep previous thumbnail data while fetching new one when segmentId changes
    placeholderData: (previousData) => previousData,
    // Avoid refetch on tab focus to prevent re-render flicker when regaining focus
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const info = thumbnailQuery.data;
  if (!info) {
    return {
      isLoading: thumbnailQuery.isLoading,
      info: null,
    };
  }

  return {
    isLoading: false,
    info,
  };
}
